export const trimJsonDataValues = (jsonData) => {
  Object.keys(jsonData).forEach(key =>
    // if value is not a string then it is an object and we should go inside it
    typeof jsonData[key] === 'string' ? jsonData[key] = jsonData[key].trim() : trimJsonDataValues(jsonData[key])
  );

  return jsonData;
};
